/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of access policies */
export enum PolicyType {
  Allow,
  Deny,
  Conditional,
  Delegated,
  Temporary,
  Emergency,
}

export type PolicyTypeArgs = PolicyType;

export function getPolicyTypeEncoder(): FixedSizeEncoder<PolicyTypeArgs> {
  return getEnumEncoder(PolicyType);
}

export function getPolicyTypeDecoder(): FixedSizeDecoder<PolicyType> {
  return getEnumDecoder(PolicyType);
}

export function getPolicyTypeCodec(): FixedSizeCodec<
  PolicyTypeArgs,
  PolicyType
> {
  return combineCodec(getPolicyTypeEncoder(), getPolicyTypeDecoder());
}
